export class FilterButtons {

	static selector = '.js-filter-buttons';

	filter;
	wrapper;
	groups = [];

	constructor(filter, wrapper) {
		this.filter = filter;
		this.wrapper = wrapper;

		this.init();
	}

	init() {
		let self = this;

		self.initGroup('.js-filter-button--filter', ['.js-filter', '.js-filter-button__submit'], function (state) {
			// while filtering is opened - hide everything rest on page
			let fx = state ? 'add' : 'remove';
			document.body.classList[fx]('filtering-opened');
		});
		// self.initGroup('.js-filter-button--ordering', ['.js-filter-ordering']);
		self.initSubmitButton();
	}

	initGroup(buttonSelector, sectionSelectors, changeStateCallback) {
		let self = this;

		let button = document.querySelector(buttonSelector);
		if (! button) {
			throw new Error(`Button with selector "${buttonSelector}" does not exist!`);
		}

		let group = {
			button: button,
			sections: [],
			callback: changeStateCallback,
		};

		sectionSelectors.forEach(selector => {
			let section = document.querySelector(selector);
			if (section) {
				group.sections.push(section);
			}
		});

		self.groups.push(group);
		self.bindGroupEventsEvent(group);
	}

	initSubmitButton() {
		let self = this;

		let submit = document.querySelector('.js-filter-button__submit');
		if (submit) {
			submit.addEventListener('click', event => {
				event.preventDefault();

				self.filter['forceUpdate'](0);
				self.scrollTop();

				return false;
			});
		}
	}

	scrollTop() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	bindGroupEventsEvent(group) {
		let self = this;

		group.button.addEventListener('click', event => {
			event.preventDefault();

			let fx = group.button.classList.contains('active') ? 'remove' : 'add';

			// reset
			self.inactiveAllGroups();

			// set
			if (fx === 'add') {
				group.button.classList[fx]('active');
				group.sections.forEach(section => {
					section.classList[fx]('active');
				});

				self.wrapper.classList.add('active');
			}

			// callback with current state in param
			if (typeof group.callback === 'function') {
				group['callback'](fx === 'add');
			}

			return false;
		});
	}

	inactiveAllGroups() {
		let self = this;

		self.groups.forEach(group => {
			group.button.classList.remove('active');
			group.sections.forEach(section => {
				section.classList.remove('active');
			});

			// callback with current state in param
			if (typeof group.callback === 'function') {
				group['callback'](false);
			}

			self.wrapper.classList.remove('active');
		});
	}
}
